import { Layout, Row, Spin } from "antd";
import { Switch } from "react-router-dom";
import { Redirect } from "react-router";
import { useEffect, useMemo } from "react";
import routes from "@/routes";
import styles from "./dashboardLayout.module.less";
import { isAuthenticated } from "@/utils/helpers";
import Sidebar from "@/components/layouts/DashboardLayout/Sidebar";
import DialogUserCUR from "@/modules/DialogUserCUR";
import { useTypedDispatch, useTypedSelector } from "@/app/store";
import C from "@/utils/constants";
import useMediaQuery from "@/hooks/useMediaquery";
import ProtectedRoute from "@/components/ProtectedRouter";
import { dashboardLayoutSlide } from "./dashboardLayout.slice";
import DialogReceiveOrder from "@/modules/DialogReceiveOrder";
import { useGetUserInfoQuery } from "@/rtk-query/userQueries";
import type { UserType } from "@/utils/types";

const { Sider } = Layout;

const CLIENT_MNGMT_ROUTE = "client-management";

function DashboardLayout() {
  const dispatch = useTypedDispatch();
  const { toggleSidebar, checkPermissionUser } = dashboardLayoutSlide.actions;
  const { isOpenSidebar, userInfo } = useTypedSelector((store) => store.dashboardLayoutSlide);
  const { currentData, isFetching: isFetchingData } = useGetUserInfoQuery();
  const isTablet = useMediaQuery(`(max-width: ${C.DESKTOP_SMALL_WIDTH}px)`);

  const accessibleRoutes = useMemo(() => {
    const isClientAdmin = (userInfo as UserType)?.roles?.some((r) => r.id === 2);
    const res = Object.values(routes);

    return !isClientAdmin ? res : res.filter((r) => r.tag !== CLIENT_MNGMT_ROUTE);
  }, [userInfo]);

  const handleToggleSidebar = () => {
    dispatch(toggleSidebar(!isOpenSidebar));
  };

  const getRoutes = (allRoutes: any[]) =>
    allRoutes
      .filter(({ layout }) => layout === "admin")
      .map((route: any, index) => {
        if (isAuthenticated() && route.path) {
          return <ProtectedRoute path={route.path} component={route.component} key={index} screenAction={route.screenAction} />;
        }
        return (
          <Redirect
            to={{
              pathname: routes.login.path,
            }}
            key={index}
          />
        );
      });

  useEffect(() => {
    if (currentData) {
      dispatch(checkPermissionUser(currentData));
    }
  }, [currentData, dispatch, checkPermissionUser]);

  useEffect(() => {
    if (isTablet) {
      dispatch(toggleSidebar(false));
    }
  }, [isTablet]);

  if (isFetchingData) {
    return (
      <Layout className={styles.layoutWrapper} style={{ justifyContent: "center" }}>
        <Row
          justify="center"
          style={{
            padding: 36,
          }}
        >
          <Spin tip="Loading" size="large" />
        </Row>
      </Layout>
    );
  }

  return (
    <Layout className={styles.layoutWrapper}>
      <Sider
        trigger={null}
        collapsible
        width={!isOpenSidebar ? 56 : 290}
        style={{
          background: "#EDEFF6",
        }}
      >
        <Sidebar userInfo={currentData} routes={accessibleRoutes} collapsed={!isOpenSidebar} onToggleSidebar={handleToggleSidebar} isTablet={isTablet} />
      </Sider>
      <Layout className="site-layout">
        <Switch>
          {getRoutes(accessibleRoutes)}
          <Redirect from="/" to={routes.masterProductList.path} />
        </Switch>
      </Layout>

      <DialogUserCUR />
      <DialogReceiveOrder />
    </Layout>
  );
}

export default DashboardLayout;
